import { useState } from "react";
import { Trash2, Ban } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useConfirm } from "@/components/ConfirmDialog";

export function DeleteEventButton({ e, onDeleted, onCancelled, className = "" }) {
  const { confirm, prompt } = useConfirm();
  const [busy, setBusy] = useState(false);
  const cancelled = e.status === "cancelled";

  const cancelFlow = async (p) => {
    const ok = await confirm({
      title: "Este evento tem reservas",
      description: `${p.orders} encomenda(s)/reserva(s) e ${p.going} confirmação(ões) de presença.\n\nPara preservar bilhetes e histórico financeiro, o evento não pode ser apagado — pode ser cancelado: as reservas param de imediato, os participantes são notificados e as encomendas afetadas podem ser reembolsadas em «Bilhetes › Encomendas».`,
      confirmLabel: "Cancelar evento",
      cancelLabel: "Voltar",
    });
    if (!ok) return;
    const reason = await prompt({ title: "Motivo do cancelamento", description: "Fica registado e é usado nos reembolsos.", placeholder: "Ex: problema com o local", required: true });
    if (!reason || reason.trim().length < 3) { if (reason !== null) toast.error("Indica um motivo"); return; }
    const { data } = await api.post(`/events/${e.id}/cancel`, { reason });
    toast.success(`Evento cancelado · ${data.affected_orders} encomenda(s) a reembolsar`);
    onCancelled?.({ ...e, status: "cancelled" });
  };

  const run = async () => {
    setBusy(true);
    try {
      const { data: p } = await api.get(`/events/${e.id}/deletion-preview`);
      if (!p.can_delete) { await cancelFlow(p); return; }
      const ok = await confirm({
        title: "Apagar este evento?",
        description: `«${e.name}» deixa de aparecer na plataforma${p.interested ? ` (${p.interested} pessoa(s) interessada(s) deixam de o ver)` : ""}. Fica apenas um registo interno da remoção. Esta ação não pode ser anulada.`,
        confirmLabel: "Apagar evento",
      });
      if (!ok) return;
      await api.delete(`/events/${e.id}`);
      toast.success("Evento apagado");
      onDeleted?.(e);
    } catch (er) {
      const d = er.response?.data?.detail;
      if (er.response?.status === 409 && d?.code === "has_reservations") { try { await cancelFlow(d); } catch (x) { toast.error(formatApiError(x.response?.data?.detail) || "Erro"); } }
      else toast.error(formatApiError(d) || "Erro");
    } finally { setBusy(false); }
  };

  if (cancelled) return <span className={`chip !text-[11px] opacity-60 ${className}`} data-testid={`event-cancelled-chip-${e.id}`}><Ban size={11} className="inline mr-1" />Cancelado</span>;
  return (
    <button type="button" onClick={run} disabled={busy} data-testid={`event-delete-${e.id}`}
      className={`chip !text-[11px] !border-red-200 !text-red-700 hover:!bg-red-50 disabled:opacity-50 ${className}`}>
      <Trash2 size={11} className="inline mr-1" />{busy ? "A verificar…" : "Apagar evento"}
    </button>
  );
}
